import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
export type HeaderVariant = 'back' | 'save' | 'empty' | 'only-title' | 'transparent';

@Component({
  selector: 'app-generic-header',
  templateUrl: './generic-header.component.html',
  styleUrls: ['./generic-header.component.scss'],
})
export class GenericHeaderComponent  implements OnInit {

  /**
   * Component designed to manage generic Headers. It can display < or ✓ with or withou title
   * @param goBack - function to execute
   * @param title - the title you want
   * @param check - if is '✓'
   * @param button - if have a button
   */

  // Input para receber a função de callback
  @Input() variant: HeaderVariant = 'back';
  @Input() title?: string;

  @Input() goBack?: () => void; // Função opcional
  @Input() modalCtrl!: ModalController

  constructor() { }

  ngOnInit() {}

  get displayTitle(): string {
    return this.title || ""; // Se title for undefined, retorna ''
  }

  handleGoBack(){
    //Specialized Implementation
    if (this.goBack){
      this.goBack();
    }
    // Generic Implementation
    else{
      this.modalCtrl.dismiss();
    }
  }
}
